<template>
  <div class="download">
    <banner title="Contact Us" />
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  }
};
</script>

<style lang="scss" scoped>
</style>